import { render } from "./TheMyTicketPurchaseDetails.vue?vue&type=template&id=4f714f78&scoped=true"
import script from "./TheMyTicketPurchaseDetails.vue?vue&type=script&lang=js"
export * from "./TheMyTicketPurchaseDetails.vue?vue&type=script&lang=js"

import "./TheMyTicketPurchaseDetails.vue?vue&type=style&index=0&id=4f714f78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f714f78"

export default script